var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", {
    staticClass: "safe-markdown",
    domProps: { innerHTML: _vm._s(_vm.html) },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }